// WhatWeDo.tsx — the copy column of the assembly set piece (Assembly.tsx).
// Mounted once, inside <div className="assembly__copy">. Owns no ref of its
// own and no section/wrap wrapper any more: Assembly.tsx owns the pin, the
// scroll listener, and the grid the H2 + three beats sit in. Each
// `data-beat` div is queried by Assembly.tsx's scroll effect (by data
// attribute, not by ref, the same decoupling markChoreography.ts uses for
// Seam.tsx) and given its opacity/translateY as a pure function of scroll
// progress; below 900px, under reduced motion, or before JS runs, the
// styles below are this file's own finished default — no transform, full
// opacity — so nothing here depends on Assembly.tsx's effect to read right.
//
// Root class is `.wwd`, deliberately NOT `.what-we-do`: index.css still
// carries `.what-we-do .sechead { margin-bottom: ... }`, sized for the old
// full-width two-row layout this file used to render. Reusing that class
// name here would silently pull ~190px of dead margin under the H2 inside
// this section's much narrower copy column.
import { CubeGlyph } from '../marks/CubeGlyph';
import './WhatWeDo.css';

export function WhatWeDo() {
  return (
    <div className="wwd">
      <div className="sechead">
        <h2>Two kinds of work, one standard.</h2>
      </div>

      <div className="wwd__beat" data-beat="1">
        <h3>
          <span className="wwd__lead">
            <CubeGlyph tone="mint" size={28} />
          </span>
          Products of our own
        </h3>
        <p>
          When we think something should exist, we build it and ship it. Our current
          product is Latently, a reader for scientific papers. Building for
          ourselves keeps us honest about what good software feels like to use.
        </p>
      </div>

      <div className="wwd__beat" data-beat="2">
        <h3>
          <span className="wwd__lead wwd__lead--pair">
            <CubeGlyph tone="ice" size={28} className="wwd__lead-back" />
            <CubeGlyph tone="peri" size={28} className="wwd__lead-front" />
          </span>
          Software for your business
        </h3>
        <p>
          The systems a business runs on every day: desktop apps, servers, and the
          connections between them. We design around how your team actually works,
          including how you interact with your customers. Then we stay on after
          launch: monthly updates, real support.
        </p>
        <span className="stamp">In daily production at 5 sites</span>
      </div>
    </div>
  );
}
